import { useEffect, useMemo, useState } from 'react';
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { db } from '../firebase';
import { useUser } from '../components/UserContext';

/**
 * My notificaciones (the bell), live. One listener, mounted once by the bell
 * in Dashboard; brokers only, and only when the org has OTs on — today every
 * notification comes from an OT.
 *
 * Reads `notificaciones where uid == me`; the rules only allow that query. The
 * list is kept to the last 60 client-side, unread first.
 *
 * @param {boolean} activo
 * @return {{rows:Array<Object>, noLeidas:Array<Object>, loading:boolean}}
 */
export function useNotificaciones(activo) {
  const { user } = useUser();
  const uid = user?.uid || null;
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(Boolean(activo));

  useEffect(() => {
    if (!activo || !uid) { setRows([]); setLoading(false); return undefined; }
    setLoading(true);
    const unsub = onSnapshot(
      query(collection(db, 'notificaciones'), where('uid', '==', uid)),
      (snap) => {
        const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
        list.sort((a, b) => {
          if (Boolean(a.leida) !== Boolean(b.leida)) return a.leida ? 1 : -1;
          return Number(b.createdAt || 0) - Number(a.createdAt || 0);
        });
        setRows(list.slice(0, 60));
        setLoading(false);
      },
      (e) => { console.error('notificaciones listener:', e); setLoading(false); }
    );
    return () => unsub();
  }, [activo, uid]);

  const noLeidas = useMemo(() => rows.filter((r) => !r.leida), [rows]);
  return { rows, noLeidas, loading };
}

export default useNotificaciones;
